import { reactLocalStorage } from 'reactjs-localstorage';

import Const from '../util/Constants';
import DateUtil from '../util/Util';
import FieldController from './FieldController';
import CountryCodes from '../util/CountryCode';

class LeadController {

  static Staff = 'responsible_person';

  static addModel = fields => {
    const user = reactLocalStorage.getObject(Const.LoggedInUser).user_id;

    let lead ={};
    const keys = Object.keys(fields);
    for(let i = 0; i < keys.length; i++) {
      if(!fields[keys[i]].editable) continue;
      const fieldType = fields[keys[i]].field_type;
      const val = fields[keys[i]].default_value;
      if(fieldType === Const.Date || fieldType === Const.DateTime) {
        lead[keys[i]] = '';
        if(val === 'today') lead[keys[i]] = DateUtil.dateToServerDateTime(new Date());
      } else if(fieldType === Const.Address) {
        lead[keys[i]] = [{}];
      } else if(keys[i] === LeadController.Staff && fieldType.includes(Const.MultiSelect)) {
        const options = FieldController.getOptions(fields[keys[i]]);
        lead[keys[i]] = options.filter(item => item.value === user);
      } else if(keys[i] === LeadController.Staff && fieldType.includes(Const.Select)) {
        const options = FieldController.getOptions(fields[keys[i]]);
        lead[keys[i]] = options.find(item => item.value === user);
      } else if(fieldType.includes(Const.MultiSelect)) {
        lead[keys[i]] = [];
        if(val && val !== '') {
          lead[keys[i]] = '~' + val.replace(',', '~') + '~';
          lead[keys[i]] = [];
        }
      } else if(fieldType.includes(Const.Phone)) {
        lead[keys[i]] = [{ code: CountryCodes.find(item => item.value === '+91'), phone: ''}];
      } else if(fieldType.includes(Const.Email) || fieldType.includes(Const.MultiValue)) {
        lead[keys[i]] = [''];
      } else {
        lead[keys[i]] = val;
      }
    }
    lead.status = Const.Active;
    return lead;
  }

  static getCustomFields = fields => {
    let customField = {};
    let keys = Object.keys(fields);
    for(let i = 0; i < keys.length; i++) {
      if(keys[i] !== 'id' && keys[i] !== 'status'
        && keys[i] !== 'firstname' && keys[i] !== 'middlename' && keys[i] !== 'lastname'
        && keys[i] !== 'gender' && keys[i] !== 'dob' && keys[i] !== 'progress'
        && keys[i] !== 'company_name' && keys[i] !== 'anniversary' && keys[i] !== 'industry'
        && keys[i] !== 'responsible_person' && keys[i] !== 'project' && keys[i] !== 'source'
        && keys[i] !== 'enquiry_date' && keys[i] !== 'email_opt' && keys[i] !== 'sms_opt'
        && keys[i] !== 'phone' && keys[i] !== 'email' && keys[i] !== 'site' && keys[i] !== 'lead_state'
        && keys[i] !== 'address'
        && keys[i] !== 'min_budget' && keys[i] !== 'max_budget' && keys[i] !== 'property_is'
        && keys[i] !== 'property_transaction' && keys[i] !== 'occupation'
        && keys[i] !== 'how_you_will_purchase' && keys[i] !== 'furnishing'
        && keys[i] !== 'miscellaneous' && keys[i] !== 'property_type' && keys[i] !== 'area'
        && keys[i] !== 'created_by' && keys[i] !== 'updated_by'
        && keys[i] !== 'created_date' && keys[i] !== 'updated_date'
        && fields[keys[i]].status !== Const.Trash) {
        customField[keys[i]] = fields[keys[i]];
      }
    }
    return customField;
  }
}
export default LeadController;